import React from 'react';
import './TopperQuotes.css';
import { Quote, Star } from 'lucide-react';

const TopperQuotes = () => {
  return (
    <section className="topper-quotes-section">
      <div className="topper-quotes-container">
        <div className="topper-quotes-card">
          <div className="topper-quotes-quote-icon">
            <Quote size={48} strokeWidth={1.5} />
          </div>

          <p className="topper-quotes-message">
            “<span className="topper-quotes-highlight">PYQ Pedia's mentorship</span> helped me stay consistent, focused, and confident. Their guidance was pivotal in clearing my exams with top ranks.”
          </p>

          <div className="topper-quotes-author">
            <img
              src="https://images.unsplash.com/photo-1607746882042-944635dfe10e"
              alt="Topper"
              className="topper-quotes-avatar"
            />
            <div className="topper-quotes-info">
              <h4 className="topper-quotes-name">Aditi Sharma</h4>
              <p className="topper-quotes-rank">AIR 12 - NEET 2025</p>
            </div>
            <div className="topper-quotes-stars">
              {[...Array(5)].map((_, index) => (
                <Star key={index} size={18} fill="#facc15" stroke="#facc15" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopperQuotes;
